import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getMyWorksToAdministrate(options = {}) {
  return _apiRequestWrap(
    ModulesMap.DONE_WORKS_MY_WORKS_TO_ADMINISTRATE,
    ModulesConfigMap[ModulesMap.DONE_WORKS_MY_WORKS_TO_ADMINISTRATE].GET_MY_WORKS_TO_ADMINISTRATE,
    options
  )
}

export default {
  [ModulesConfigMap[ModulesMap.DONE_WORKS_MY_WORKS_TO_ADMINISTRATE].GET_MY_WORKS_TO_ADMINISTRATE]: _getMyWorksToAdministrate
}